import api from "./api";
import { API_URL_VERSION } from "../constants/environment";

export const ENDPOINT_PERMISSOES = API_URL_VERSION + 'permissoes'
export const ENDPOINT_PERMISSOES_GET_DETAIL_UPDATE = API_URL_VERSION + 'permissoes/'

export const PermissionAdminUnit = {
    DAT: { value: "DAT", labelKey: "dat" },
    DILIGENCE: { value: "Diligência", labelKey: "diligence" },
    ADMINISTRATIVE_BOARD_OF_APPEALS_INFRACTIONS: { value: "Junta Administrativa de Recursos de Infrações", labelKey: "administrative-board-of-appeals-infractions" },
    LEGAL_ADVICE: { value: "Assessoria Jurídica", labelKey: "legal-advice" },
    FINANCIAL: { value: "Financeiro", labelKey: "financial" }
};

export const permissionsService = {
    list: async () => {
        try {
            const response = await api.get(ENDPOINT_PERMISSOES);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "settings.user.permission.messages.erros.list";
        }
    },

    find: async (id) => {
        try {
            const response = await api.get(`${ENDPOINT_PERMISSOES_GET_DETAIL_UPDATE}${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "settings.user.permission.messages.erros.find";
        }
    },

};
